//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },

  emits: ['updateFilter'],

  methods: {
    filtersChanged(id, checked) {
      this.$emit('updateFilter', id, checked)
    },
  },
}
